<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row>
        <el-form-item
          :label="$l('form_label_serial_number_name') || '流水号名称'"
          prop="serialName"
        >
          <el-input
            v-model="formData.serialName"
            :placeholder="
              $l('form_label_pe_serial_number_name') || '请输入流水号名称'
            "
          >
          </el-input>
        </el-form-item>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_the_current_number') || '当前编号'"
          >
            <el-input
              v-model="formData.currentNo"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_serial_number_type') || '流水号类型'"
            prop="serialType"
          >
            <el-select
              filterable
              v-model="formData.serialType"
              :placeholder="
                $l('form_label_pleaseEnter_serial_number_type') ||
                  '请选择流水号类型'
              "
            >
              <el-option label="BILL" value="BILL" />
              <el-option label="ID" value="ID" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_growth_pattern') || '增长方式'">
            <el-select
              filterable
              v-model="formData.isAddType"
              :placeholder="
                $l('form_label_pleaseEnter_growth_pattern') || '请选择增长方式'
              "
            >
              <el-option
                :label="$l('form_label_ progressive_increase') || '递增'"
                value="A"
              />
              <el-option
                :label="$l('form_label_day_progressive_increase') || '日递增'"
                value="B"
              />
              <el-option
                :label="$l('form_label_month_progressive_increase') || '月递增'"
                value="C"
              />
              <el-option
                :label="$l('form_label_ year_progressive_increase') || '年递增'"
                value="D"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_date_format') || '日期格式'">
            <dict-select
              clearable
              v-model="formData.dateType"
              :body="dateTypeParams"
              url="/sys/common/dict/system"
              :placeholder="
                $l('form_label_ps_a_date_format') || '请选择日期格式'
              "
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_special_prefix') || '特殊前缀'">
            <el-input
              v-model="formData.specialPrefix"
              :placeholder="
                $l('form_label_pe_Special_prefix') || '请输入特殊前缀'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_documents_prefix') || '单据前缀'"
          >
            <el-input
              v-model="formData.billPrefix"
              :placeholder="
                $l('form_label_pleaseEnter_documents_prefix') ||
                  '请输入单据前缀'
              "
              v-bind:disabled="billPrefixDisabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_digital_length') || '数字长度'">
            <el-input-number
              v-model="formData.numberLength"
              :placeholder="
                $l('form_label_pleaseEnter_serial_number_length') ||
                  '请输入流水号中的数字长度'
              "
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_total_lenght') || '总长度'">
            <el-input-number
              v-model="formData.totalLength"
              :placeholder="
                $l('form_label_pleaseEnter_serial_total_number_length') ||
                  '请输入流水号总长度'
              "
              controls-position="right"
              style="width:100%"
              :disabled="true"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_initiate_mode') || '启用状态'"
            prop="isActive"
          >
            <el-radio-group v-model="formData.isActive">
              <el-radio label="Y">{{
                $l('form_radio_is_enabled') || '已启用'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_radio_not_enabled') || '未启用'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item
          :label="$l('form_label_serial_number_instructions') || '流水号说明'"
        >
          <el-input
            type="textarea"
            v-model="formData.serialDescription"
            :placeholder="
              $l('form_label_pleaseEnter_Serial_number_instructions') ||
                '请输入流水号说明'
            "
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    serialName: String,
    type: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      formData: { isActive: 'Y', totalLength: 0 },
      dateTypeParams: { dictType: 'dateType' },
      rules: {
        serialName: [
          {
            required: true,
            message:
              this.$l('form_label_pe_serial_number_name') || '请输入流水号名称',
            trigger: 'blur',
          },
        ],
        serialType: [
          {
            required: true,
            message:
              this.$l('form_label_pleaseEnter_serial_number_type') ||
              '请选择流水号类型',
            trigger: 'change',
          },
        ],
        isActive: [
          {
            required: true,
            message:
              this.$l('form_label_select_enable_or_not') || '请选择是否启用',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    billPrefixDisabled() {
      return this.formData.serialType === 'ID'
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    /**
     * 侦听formDate里某些属性，计算流水号总长度
     */
    'formData.serialType'() {
      this.updateTotalLength()
    },
    'formData.numberLength'() {
      this.updateTotalLength()
    },
    'formData.billPrefix'() {
      this.updateTotalLength()
    },
    'formData.specialPrefix'() {
      this.updateTotalLength()
    },
    'formData.dateType'() {
      this.updateTotalLength()
    },
  },
  methods: {
    /**
     * 计算流水号总长度
     */
    updateTotalLength() {
      if (this.formData.serialType === 'ID') {
        this.formData.billPrefix = null
      }

      this.formData.totalLength = 0
      if (this.formData.numberLength) {
        this.formData.totalLength += this.formData.numberLength
      }
      if (this.formData.billPrefix) {
        this.formData.totalLength += this.formData.billPrefix.length
      }
      if (this.formData.specialPrefix) {
        this.formData.totalLength += this.formData.specialPrefix.length
      }
      if (this.formData.dateType) {
        this.formData.totalLength += this.formData.dateType.length
      }
    },
    getData() {
      if (!this.serialName) return
      this.$api
        .sysSerialNoRuleDetailApi({
          serialName: this.serialName,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      if (this.type == 'add') {
        this.$api
          .sysSerialNoRuleSaveApi(this.formData)
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      } else if (this.type == 'edit') {
        this.$api
          .sysSerialNoRuleModifyApi(this.formData)
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '修改成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
